import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Flex } from "@faire/web--source/slate/Layout";
import * as React from "react";
import styled from "styled-components";
export var MobileAppIcon = function(param) {
    var icon = param.icon, size = param.size;
    return /*#__PURE__*/ _jsx(Wrapper, {
        $size: size,
        children: icon !== null && icon !== void 0 ? icon : /*#__PURE__*/ _jsx(Wrapper, {
            $size: size,
            children: /*#__PURE__*/ _jsx("svg", {
                xmlns: "https://www.w3.org/2000/svg",
                width: "300pt",
                height: "300pt",
                viewBox: "0 0 300 300",
                children: /*#__PURE__*/ _jsx("g", {
                    transform: "translate(0,300) scale(0.05,-0.05)",
                    fill: Core.icon.default,
                    stroke: "none",
                    children: /*#__PURE__*/ _jsx("path", {
                        d: "M1820 4282 c0 -11 27 -24 60 -30 33 -7 86 -17 117 -23 193 -37 212 -168 196 -1359 -14 -1113 -17 -1123 -284 -1201 -201 -58 -124 -69 501 -69 612 0 723 13 479 54 -272 47 -274 52 -285 748 l-8 552 217 -9 c419 -16 564 -115 669 -453 86 -276 98 -218 98 458 0 508 -5 610 -28 610 -18 0 -35 -42 -50 -125 -52 -296 -230 -400 -719 -420 l-187 -8 9 582 c4 319 15 597 24 616 14 31 49 35 324 35 611 0 763 -62 1080 -440 183 -219 195 -184 52 153 -65 152 -124 293 -131 312 -14 40 -2134 56 -2134 17z"
                    })
                })
            })
        })
    });
};
var Wrapper = styled(Flex).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-3177c766-0"
})([
    "width:",
    ";height:",
    ";flex-shrink:0;filter:drop-shadow(0px 0px 10px rgba(0,0,0,0.1));background:",
    ";"
], function(param) {
    var size = param.$size;
    return size !== null && size !== void 0 ? size : "44px";
}, function(param) {
    var size = param.$size;
    return size !== null && size !== void 0 ? size : "44px";
}, Core.surface.inverse);
